import dayjs from "dayjs"
import {observer} from "mobx-react"
import {WheelchairList} from "pages/dashboard/wheelchair/WheelchairList"
import {ReactNode, useEffect, useState} from "react"
import {useRootStore} from "store/useRootStore"
import {DeviceStatusCategory} from "store/dashboard/DashboardStore"

export const WheelchairStatusInfoPanel = observer(() => {
    const {
        dashboardStore: {
            map,
            deviceStatusFilterCondition,
            setShowDeviceStatusInListFilter,
            setDeviceStatusCategory,
            counter,
            showDeviceStatusInfoList,
            deviceStatusCategory
        }
    } = useRootStore()
    const existFilter = deviceStatusFilterCondition && deviceStatusFilterCondition.length > 0
    const toggleShowOnlyWorkingWheelchair = () => {
        if (deviceStatusFilterCondition && deviceStatusFilterCondition.length > 0) {
            setShowDeviceStatusInListFilter(null)
            return
        }
        setShowDeviceStatusInListFilter(["WORKING"]);
    }

    useEffect(() => {
        if (!map) return
        map.relayout()
    }, [showDeviceStatusInfoList])

    if (!showDeviceStatusInfoList) {
        return null
    }
    return (
        <div className="column is-one-quarter main-lbox">
            <div className="columns lbox-top" style={{position: "relative", marginBottom: 0}}>
                <Title/>
                <div className="is-size-6" style={{marginTop: 45, marginLeft: 18}}>
                    <CountTag name="ttl" click={() => setDeviceStatusCategory("ALL")}
                              selected={deviceStatusCategory === "ALL"}>
                        전체 : {counter.count.toLocaleString()}대</CountTag>
                    <CountTag name="normal" click={() => setDeviceStatusCategory("NORMAL")}
                              selected={deviceStatusCategory === "NORMAL"}>
                        정상 : {counter.normalCount.toLocaleString()}대</CountTag>
                    <CountTag name="not-running" click={() => setDeviceStatusCategory("NON_OPERATION")}
                              selected={deviceStatusCategory === "NON_OPERATION"}>
                        미운행 : {counter.noneOperationCount.toLocaleString()}대</CountTag>
                    {/*<CountTag name="poweroff">종료 : {counter.powerOffCount.toLocaleString()}대</CountTag>*/}
                    <CountTag name="error" click={() => setDeviceStatusCategory("ERROR")}
                              selected={deviceStatusCategory === "ERROR"}>
                        점검 : {counter.errorCount.toLocaleString()}대</CountTag>
                    <CountTag name="power-disconnected" click={() => setDeviceStatusCategory("POWER_DISCONNECTED")}
                              selected={deviceStatusCategory === "POWER_DISCONNECTED"}>
                        전원분리 : {counter.powerDisconnectedCount.toLocaleString()}대</CountTag>
                    <CountTag name="impact" click={() => setDeviceStatusCategory("EMERGENCY")}
                              selected={deviceStatusCategory === "EMERGENCY"}>
                        긴급 : {counter.emergencyCount.toLocaleString()}대</CountTag>
                </div>

            </div>
            <WheelchairList/>
        </div>
    )
})
const dateFormat = "YYYY/MM/DD HH:mm:ss"
const Title = observer(() => {
    const [time, setTime] = useState<string>("")
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setTime(dayjs().format(dateFormat))
        }, 1000)
        return () => {
            if (timeoutId)
                clearTimeout(timeoutId)
        }
    }, [time])
    return (
        <div className="mr10 mx-auto" style={{position: 'absolute', top: 17, left: 20}}>
            {/*<div className="is-size-4 mt10 has-text-success-light">등록된 장비 목록</div>*/}
            <div className="is-size-6 mt5">
                <span className="has-text-light">현재시간</span> •
                <span className="has-text-success">{time}</span>
            </div>
        </div>
    )
})

const CountTag = ({
                      name,
                      children,
                      click,
                      selected
                  }: { name: string, children: ReactNode, click: () => void, selected?: boolean }) => {
    return (
        <span className={`tag is-size-6 ${TagClassName[name]} ml-1 is-clickable ${!selected && 'is-light'}`}
              onClick={click}>
            {children}
        </span>
    )
}

export const TagClassName: { [key: string]: string } = {
    "ttl": "is-success",
    "not-running": "is-info",
    "normal": "is-primary",
    "poweroff": "is-info",
    "impact": "is-danger",
    "error": "is-warning",
    "power-disconnected": "is-link"
}